module.exports = __webpack_public_path__ + "static/x86-appjgq.293cd67f.png";